import React, { useState } from 'react';
import { Grid, Typography, Box } from '@mui/material';
import ProjectCard from '../components/ProjectCard';
import ProjectModal from '../components/ProjectModal';
import poli1 from '../assets/projects/poli1.jpeg';
import poli2 from '../assets/projects/poli2.jpeg';
import poli3 from '../assets/projects/poli3.jpeg';
import poli4 from '../assets/projects/poli4.jpeg';
import poli5 from '../assets/projects/poli5.jpeg';

const PROJECTS = [
  {
    title: 'Picosatellite Weather Platform',
    description:
      'Co-led the design of a pico-satellite to capture high-altitude environmental data and stream it into real-time dashboards for researchers.',
    image: 'https://www.heraldo.mx/wp-content/uploads/2018/11/PICOSATELITE-SERGIO-opt.jpg',
    gallery: [
      {
        original: 'https://www.heraldo.mx/wp-content/uploads/2018/11/PICOSATELITE-SERGIO-opt.jpg',
        thumbnail: 'https://www.heraldo.mx/wp-content/uploads/2018/11/PICOSATELITE-SERGIO-opt.jpg',
      },
    ],
    media: 'https://www.heraldo.mx/dan-muestra-de-su-talnto-en-una-mision-espacial/',
    tag: 'Space Systems',
    year: '2019',
  },
  {
    title: 'Expociencias Smart Pollination Lab',
    description:
      'Built an AI-enhanced smart garden that supports bee pollination through adaptive lighting, irrigation, and sensor-driven automation.',
    image: poli2,
    gallery: [
      { original: poli1, thumbnail: poli1 },
      { original: poli2, thumbnail: poli2 },
      { original: poli3, thumbnail: poli3 },
      { original: poli4, thumbnail: poli4 },
      { original: poli5, thumbnail: poli5 },
    ],
    media: 'https://www.elsoldelcentro.com.mx/doble-via/ecologia/intentan-salvar-a-polinizadores-4388119.html',
    tag: 'IoT · Sustainability',
    year: '2020',
  },
];

const Projects = () => {
  const [open, setOpen] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);

  const handleLearnMore = (project) => {
    setSelectedProject(project);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedProject(null);
  };

  return (
    <Box>
      <Typography variant="overline" sx={{ color: 'secondary.light', letterSpacing: 2 }}>
        Experiments &amp; builds
      </Typography>
      <Typography variant="h4" gutterBottom sx={{ fontWeight: 700 }}>
        Projects
      </Typography>
      <Typography variant="body1" sx={{ color: 'text.secondary', maxWidth: 640, mb: 4 }}>
        A selection of prototypes and competitions where I learned to blend experimentation with
        execution, taking ideas from sketch to shipped experiences.
      </Typography>

      <Grid container spacing={4}>
        {PROJECTS.map((project, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <ProjectCard {...project} onLearnMore={() => handleLearnMore(project)} />
          </Grid>
        ))}
      </Grid>

      <ProjectModal open={open} onClose={handleClose} project={selectedProject} />
    </Box>
  );
};

export default Projects;
